import React from "react";

// Components
import ScrollToTop from "components/Utils/ScrollToTop/ScrollToTop";

// Libraries & Packages
import { Route, Routes } from "react-router-dom";

// Pages
import HomePage from "pages/HomePage/HomePage";
import ServicePage from "pages/ServicePage/ServicePage";
import ProjectPage from "pages/ProjectPage/ProjectPage";
import AboutMePage from "pages/AboutMePage/AboutMePage";
import TechnologyStackPage from "pages/TechnologyStackPage/TechnologyStackPage";
import ContactMePage from "pages/ContactMePage/ContactMePage";

function Router() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Project */}
        <Route
          path="/service/:serviceID/:projectID"
          element={<ProjectPage />}
        />
        {/* Service */}
        <Route path="/service/:serviceID" element={<ServicePage />} />
        {/* Contact Me */}
        <Route path="/contact-me" element={<ContactMePage />} />
        {/* Technology Stack */}
        <Route path="/technology-stack" element={<TechnologyStackPage />} />
        {/* About Me */}
        <Route path="/about-me" element={<AboutMePage />} />
        {/* Home */}
        <Route path="/" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default Router;
